// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3UJCO","rootSmall":"AddTileButton_rootSmall__31-Hd"};